import { combineReducers } from 'redux'

import tariffs from './tariffs/reducers'

const billingReducer = combineReducers({
  tariffs,
})

export default billingReducer
